const ProgressBar = ({ progress }) => {
    return (
        <div className="progress-bar-container-container">
            <div className="progress-bar-container">
                <div className="progress-bar" style={{ width: `${progress * 100}%` }} />
            </div>
        </div>
    );
};

export default ProgressBar;
